import { useQuery } from '@tanstack/react-query';
import { AppVersionConfigEntity, AppVersionService } from 'services/openapi';

import { AppVersionServiceKeys } from './constants';

export const useGetAppVersionConfigQuery = (enabled: boolean = true) => {
  const queryKey = [AppVersionServiceKeys.GET_APP_VERSION_CONFIG];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<AppVersionConfigEntity, Error>({
    queryKey,
    queryFn: () => AppVersionService.appVersionControllerGetAppVersionConfig(),
    retry: 0,
    refetchOnWindowFocus: false,
    enabled,
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data,
    isError,
    queryKey,
    refetch,
  };
};
